import Cabecalho from '@/components/ui/Cabecalho';
import Cartao from '@/components/ui/Cartao';
import type { Documento } from '@/conteudo/tipos';

// Deixa em negrito o que estiver entre **asteriscos duplos**.
function ComNegrito({ texto }: { texto: string }) {
  const partes = texto.split('**');
  return (
    <>
      {partes.map((parte, i) =>
        i % 2 === 1 ? (
          <strong key={i} className="font-semibold text-foreground-900">
            {parte}
          </strong>
        ) : (
          <span key={i}>{parte}</span>
        ),
      )}
    </>
  );
}

// Página de texto (Política de privacidade / Termos de uso): coluna central,
// índice clicável no topo e o texto abaixo.
export default function PaginaTexto({ documento }: { documento: Documento }) {
  return (
    <div className="min-h-screen bg-background-50">
      <Cabecalho
        titulo={documento.titulo}
        subtitulo={documento.atualizado}
        larguraMaxima="max-w-[720px]"
      />

      <main className="mx-auto w-full max-w-[720px] px-4 py-8 md:px-6 md:py-10">
        <Cartao className="p-5 md:p-6">
          <p className="text-xs font-semibold uppercase tracking-wide text-foreground-500">
            Nesta página
          </p>
          <nav className="mt-3 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
            {documento.secoes.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                className="flex cursor-pointer items-start gap-2 text-sm text-primary-700 transition-colors hover:text-primary-900 hover:underline"
              >
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
                  <i className="ri-arrow-right-s-line" />
                </span>
                <span className="min-w-0">{s.titulo}</span>
              </a>
            ))}
          </nav>
        </Cartao>

        <article className="mt-8 space-y-8">
          {documento.secoes.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-20">
              <h2 className="text-[20px] font-bold leading-snug text-foreground-950">
                {s.titulo}
              </h2>
              <div className="mt-3 space-y-3">
                {s.blocos.map((bloco, i) =>
                  bloco.tipo === 'p' ? (
                    <p key={i} className="text-base leading-relaxed text-foreground-700">
                      <ComNegrito texto={bloco.texto} />
                    </p>
                  ) : (
                    <ul key={i} className="space-y-2">
                      {bloco.itens.map((item, j) => (
                        <li
                          key={j}
                          className="flex gap-2.5 text-base leading-relaxed text-foreground-700"
                        >
                          <span className="mt-2 flex h-1.5 w-1.5 shrink-0 items-center justify-center rounded-full bg-primary-400" />
                          <span className="min-w-0">
                            <ComNegrito texto={item} />
                          </span>
                        </li>
                      ))}
                    </ul>
                  ),
                )}
              </div>
            </section>
          ))}
        </article>
      </main>
    </div>
  );
}